export const dialogConfig = {
    delete: {
        title: 'workspace.taskCenter.deleteTask',
        content: 'workspace.taskCenter.confirmDeleteTask',
        confirmButtonText: 'snapBusiness.global.btn.delete',
        confirmType: 'danger',
    },
    cancel: {
        title: 'workspace.taskCenter.cancelTask',
        content: 'workspace.taskCenter.confirmCancelTask',
        confirmButtonText: 'workspace.taskCenter.cancelTask',
    },
    cancelAiTagging: {
        title: 'SmartAnnotation.RESULT.cancelTask.title',
        content: 'SmartAnnotation.RESULT.cancelTask.message',
        confirmText: 'SmartAnnotation.RESULT.cancelTask.confirm',
        cancelText: 'SmartAnnotation.RESULT.cancelTask.continue',
        confirmType: 'danger',
    },
    empty: {
        title: 'workspace.taskCenter.emptyLog',
        content: 'workspace.taskCenter.confirmEmptyTask',
        confirmButtonText: 'snapBusiness.global.btn.delete',
        confirmType: 'danger',
    },
};
export const undoDialogConfig = {
    COPY_PATENT: {
        title: 'undoAction.task.copyPatentName',
        content: 'undoAction.task.copyPatentDesc',
        confirmButtonText: 'snapBusiness.global.btn.ok',
    },
    MOVE_PATENT: {
        title: 'undoAction.task.movePatentName',
        content: 'undoAction.task.movePatentDesc',
        confirmButtonText: 'snapBusiness.global.btn.ok',
    },
    BULK_EDIT: {
        title: 'undoAction.task.bulkIndexName',
        content: 'undoAction.task.bulkIndexDesc',
        tip: 'undoAction.task.indexTips',
        confirmButtonText: 'snapBusiness.global.btn.ok',
    },
    AUTO_LABEL_BULK_EDIT: {
        title: 'undoAction.task.autoLabelIndexName',
        content: 'undoAction.task.ruleIndexDesc',
        tip: 'undoAction.task.indexTips',
        confirmButtonText: 'snapBusiness.global.btn.ok',
    },
    SMART_CUSTOM_FIELD: {
        title: 'undoAction.task.AIIndexName',
        content: 'undoAction.task.AIIndexDesc',
        tip: 'undoAction.task.AIIndexTips',
        confirmButtonText: 'snapBusiness.global.btn.ok',
    },
    HIRO_AGENT_BATCH_LABEL: {
        title: 'undoAction.task.hiroAgentIndexName',
        content: 'undoAction.task.hiroAgentIndexDesc',
        tip: 'undoAction.task.indexTips',
        confirmButtonText: 'snapBusiness.global.btn.ok',
    },
};
